import { render, staticRenderFns } from "./DialogInicioPosto.vue?vue&type=template&id=ba5ebd40&"
import script from "./DialogInicioPosto.vue?vue&type=script&lang=js&"
export * from "./DialogInicioPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports